import ProgramCard from "../programs/ProgramCard";

export const renderProgramCard = (data, slug = undefined) => data.map((item, key) => <ProgramCard key={key} item={item} slug={slug} />);
